import { getData } from '@/utils/apiHelper.js';

/**
 * Used to download csv files.
 * @param {string} downloadUrl url for downloading data.
 * @param {object} downloadParams request param for downloading data.
 * @param {string} fileName name of file.
 */
async function downloadCsvFile(downloadUrl, downloadParams, fileName) {
  const downloadRes = await getData(`${downloadUrl}`, downloadParams);
  const fileURL = window.URL.createObjectURL(new Blob([downloadRes.data]));
  const fileLink = document.createElement('a');
  fileLink.href = fileURL;
  fileLink.setAttribute('download', fileName);
  document.body.appendChild(fileLink);
  fileLink.click();
}

export default downloadCsvFile;
